import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  abstracts: []
};

const abstractSlice = createSlice({
  name: "abstracts",
  initialState,
  reducers: {
    setAbstracts: (state, action) => {
      state.abstracts = action.payload;
    },
    removeAbstract: (state, action) => {
      state.abstracts = state.abstracts.filter(
        (abstract) => abstract.pk !== action.payload
      );
    },
    addAbstract: (state, action) => {
      state.abstracts.push(action.payload);
    },
    updateAbstract: (state, action) => {
      const index = state.abstracts.findIndex(
        (a) => a.pk === action.payload.pk
      );
      if (index !== -1) {
        state.abstracts[index] = action.payload;
      }
    },
  },
});

export const { setAbstracts, removeAbstract, addAbstract, updateAbstract } =
  abstractSlice.actions;
export default abstractSlice.reducer;
